import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Custom markdown extensions with Remark and HAST handlers",
  "description": "",
  "published": "2019-04-08T00:00:00.000Z",
  "redirect_from": ["/blog/custom-markdown-extensions-with-remark-and-hast-handlers/swizec/9018"],
  "categories": "Front End, Technical",
  "hero": "./img/Mg1nuYD.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Markdown is all the rage these days.`}</p>
    <p>{`A simple text format for rich documents, you see it everywhere from GitHub issues to Slack messages. Even Facebook supports it in their business version. Soon their pleb version too, I hear.`}</p>
    <p>{`With the rise of Gatsby and other static site builders, markdown is an increasingly popular choice for text-heavy webapps. Write content in Markdown, parse and render to React or HTML.`}</p>
    <p>{`Easy to build the layout, easy to write the content. Perfect 👌`}</p>
    <p>{`Markdown for content-heavy apps is what I wanna talk about today. Because I discovered how you can make markdown do anything you want. Anything. It's amazing.`}</p>
    <lite-youtube {...{
      "videoid": "QtSSNLh_PBs",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`I use markdown to write these letters. And my blogs. And my workshop materials.`}</p>
    <p>{`One of the tools that helps me do that is `}<a parentName="p" {...{
        "href": "https://techletter.app/"
      }}>{`TechLetterApp`}</a>{`. Takes my Markdown and turns code, youtube links, and tweets into screenshots. Makes them work in email :)`}</p>
    <p>{`But TechLetterApp had a terrible bug.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b8bad3e2e55b28dc1da6001c32e9ab51/af975/Mg1nuYD.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "40.35874439461883%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'161\\'%20viewBox=\\'0%200%20400%20161\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M231%2042v18l1%2017h3l6%201a144%20144%200%200041-1c3%200%205%200%205-2V41h-28l-28%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b8bad3e2e55b28dc1da6001c32e9ab51/ca0a1/Mg1nuYD.webp 223w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/75680/Mg1nuYD.webp 445w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/8d1ba/Mg1nuYD.webp 890w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/3838e/Mg1nuYD.webp 1335w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/e11e5/Mg1nuYD.webp 1780w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/e6ef2/Mg1nuYD.webp 2478w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/b8bad3e2e55b28dc1da6001c32e9ab51/e92b6/Mg1nuYD.png 223w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/e66bf/Mg1nuYD.png 445w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/4ef49/Mg1nuYD.png 890w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/4e814/Mg1nuYD.png 1335w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/701e9/Mg1nuYD.png 1780w", "/static/b8bad3e2e55b28dc1da6001c32e9ab51/af975/Mg1nuYD.png 2478w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/b8bad3e2e55b28dc1da6001c32e9ab51/4ef49/Mg1nuYD.png",
              "alt": "Mg1nuYD",
              "title": "Mg1nuYD",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Code blocks would eat each other. Linking to Twitter usernames with an `}<inlineCode parentName="p">{`@`}</inlineCode>{` corrupted the output. Image links got confused as well. `}<inlineCode parentName="p">{`[![]()]()`}</inlineCode>{`.`}</p>
    <p>{`Basically, the Markdown parser was shit.`}</p>
    <p>{`I was using `}<a parentName="p" {...{
        "href": "https://github.com/showdownjs/showdown"
      }}>{`Showdown`}</a>{`. Worked great for simple stuff, broke down on the hard stuff.`}</p>
    <p>{`Maybe my regex-based extensions broke it.`}</p>
    <p>{`Or the fact that it used Regex to render Markdown, which is not a regular language. Same problem as using Regex to parse HTML. `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/1732348/regex-match-open-tags-except-xhtml-self-contained-tags"
      }}>{`You can't`}</a></p>
    <p>{`Either way, the solution was a rewrite to `}<a parentName="p" {...{
        "href": "https://github.com/remarkjs/remark"
      }}>{`Remark`}</a></p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`You know when you have a bug in software you wrote that annoys you almost every day that you use it but you know fixing it will take rewriting all of the core code of that tool and it's just so hard to get off your butt and start coding? `}<a parentName="p" {...{
          "href": "https://t.co/uSiqt1HUDR"
        }}>{`pic.twitter.com/uSiqt1HUDR`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1114672906607325184"
      }}>{`April 6, 2019`}</a></blockquote>
    <p>{`Now TechLetterApp works great.`}</p>
    <p>{`Time to add more Markdown extensions 😛`}</p>
    <h2 {...{
      "id": "build-your-own-markdown-extension"
    }}>{`Build your own Markdown extension`}</h2>
    <p>{`You need 3 ingredients to build your own custom Markdown extension.`}</p>
    <ol>
      <li parentName="ol">{`A Remark plugin `}<em parentName="li">{`that creates a custom node type`}</em></li>
      <li parentName="ol">{`A HAST handler `}<em parentName="li">{`that knows how to use it`}</em></li>
      <li parentName="ol">{`A renderer `}<em parentName="li">{`that allows custom HAST handlers`}</em></li>
    </ol>
    <p>{`I built a Markdown extension that understands YouTube and Twitter links as a special `}<inlineCode parentName="p">{`screenshot`}</inlineCode>{` node.`}</p>
    <p>{`We'll use that to talk about how to build a Markdown extension. You could use the same approach to create completely new Markdown syntax.`}</p>
    <h2 {...{
      "id": "1-a-remark-plugin"
    }}>{`1. A Remark plugin`}</h2>
    <p>{`Remark is a Markdown parser/compiler that uses plugins to do its thing.`}</p>
    <p>{`I've written about `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/buildremark-plugin-supercharge-static-site/swizec/8860"
      }}>{`How to build a Remark plugin to supercharge your static site`}</a>{` before. Here's the process in a nutshell:`}</p>
    <ol>
      <li parentName="ol">{`Remark parses Markdown to an AST (abstract syntax tree)`}</li>
      <li parentName="ol">{`Remark then uses `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Visitor_pattern"
        }}>{`the visitor pattern`}</a>{` to run plugins in sequence on each node`}</li>
      <li parentName="ol">{`Plugins transform nodes to new or different nodes`}</li>
    </ol>
    <p>{`That 3rd part is what we're building 👉 a method that takes a `}<inlineCode parentName="p">{`node`}</inlineCode>{` object and transforms it to a different `}<inlineCode parentName="p">{`node`}</inlineCode>{` object.`}</p>
    <p>{`My link-to-screenshot plugin looks like this:`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">import visit from "unist-util-visit";
import Url from "url-parse";

function getScreenshotUrl(url) {
    return \`https://84wz7ux5rc.execute-api.us-east-1.amazonaws.com/default/screenshot-as-a-service-dev-screenshot-function?url=\${url}\`;
}

function remarkUrlThumbnail({ domains = [] }) {
    return tree =>
        new Promise(async (resolve, reject) => {
            const nodesToChange = [];
            visit(tree, "link", node => {
                const url = new Url(node.url);
                const thumbnailable = domains.some(
                    d => url.hostname.replace("www.", "") === d
                );

                if (thumbnailable) {
                    nodesToChange.push({
                        node
                    });
                }
            });
            for (const { node } of nodesToChange) {
                node.type = "screenshot";
                node.url = getScreenshotUrl(node.url);
                node.link = node.url;
            }

            resolve();
        });
}

export default remarkUrlThumbnail;
`}</code></pre>
    <p>{`34 lines of prettified code in total. Lemme explain :)`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">import visit from "unist-util-visit";
import Url from "url-parse";
`}</code></pre>
    <p>{`We use the `}<inlineCode parentName="p">{`visit`}</inlineCode>{` util from unist utils to help us visit specific nodes. Easier than writing our own recursion-based tree-crawling code.`}</p>
    <p>{`That's the stuff of whiteboard interviews and I never want to do it myself in real life. Too hard.`}</p>
    <p>{`We use `}<inlineCode parentName="p">{`Url`}</inlineCode>{` to parse URLs. You could write a regex for it and that's fraught with dangers. Let someone else deal with the edge cases :)`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">function getScreenshotUrl(url) {
    return \`https://84wz7ux5rc.execute-api.us-east-1.amazonaws.com/default/screenshot-as-a-service-dev-screenshot-function?url=\${url}\`;
}
`}</code></pre>
    <p><inlineCode parentName="p">{`getScreenshotUrl`}</inlineCode>{` is a helper method that takes a URL and returns a URL based on my screenshot-as-a-service AWS Lambda. It knows how to take screenshots and make thumbnails of various types of sites.`}</p>
    <p>{`I should write about how that works some time 🤔`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">function remarkUrlThumbnail({ domains = [] }) {
    return tree =>
        new Promise(async (resolve, reject) => {
            const nodesToChange = [];
            visit(tree, "link", node => {
                const url = new Url(node.url);
                const thumbnailable = domains.some(
                    d => url.hostname.replace("www.", "") === d
                );

                if (thumbnailable) {
                    nodesToChange.push({
                        node
                    });
                }
            });
            for (const { node } of nodesToChange) {
                node.type = "screenshot";
                node.url = getScreenshotUrl(node.url);
                node.link = node.url;
            }

            resolve();
        });
}
`}</code></pre>
    <p><inlineCode parentName="p">{`remarkUrlThumbnail`}</inlineCode>{` is the work horse here. Split into two parts.`}</p>
    <p>{`First it finds all the candidate nodes. Then it changes them.`}</p>
    <p>{`We `}<inlineCode parentName="p">{`visit()`}</inlineCode>{` every `}<inlineCode parentName="p">{`link`}</inlineCode>{` node, those are URLs, and check if they fit a list of domains that we want to thumbnailify. List comes from config, I'll show you in a bit.`}</p>
    <p>{`Each match is pushed to a `}<inlineCode parentName="p">{`nodesToChange`}</inlineCode>{` array.`}</p>
    <p>{`Then we loop through the array with a `}<inlineCode parentName="p">{`for`}</inlineCode>{` loop and change each node type to a `}<inlineCode parentName="p">{`screenshot`}</inlineCode>{`, define the new `}<inlineCode parentName="p">{`url`}</inlineCode>{`, and keep the old one in `}<inlineCode parentName="p">{`link`}</inlineCode>{`.`}</p>
    <p>{`You can add any property you might need here. The world is your oyster and the `}<inlineCode parentName="p">{`node`}</inlineCode>{` is but a JavaScript object for you to play with.`}</p>
    <h2 {...{
      "id": "2-a-hast-handler"
    }}>{`2. A HAST handler`}</h2>
    <p>{`Ok so you have a new type of node: `}<inlineCode parentName="p">{`screenshot`}</inlineCode>{`. Now what?`}</p>
    <p>{`Most Remark renderers, like `}<a parentName="p" {...{
        "href": "https://github.com/remarkjs/remark-react"
      }}>{`remark-react`}</a>{` which renders to React, and `}<a parentName="p" {...{
        "href": "https://github.com/remarkjs/remark-html"
      }}>{`remark-html`}</a>{` which renders to HTML, use an intermediate layer called HAST – HTML Abstract Syntax Tree.`}</p>
    <p>{`HAST takes a Markdown AST and turns it into an HTML AST. Goes from `}<inlineCode parentName="p">{`link`}</inlineCode>{` and `}<inlineCode parentName="p">{`bold`}</inlineCode>{` and `}<inlineCode parentName="p">{`quote`}</inlineCode>{` nodes to `}<inlineCode parentName="p">{`a`}</inlineCode>{` and `}<inlineCode parentName="p">{`b`}</inlineCode>{` and `}<inlineCode parentName="p">{`blockquote`}</inlineCode>{`. That sort of thing.`}</p>
    <p>{`But it won't know what to do with `}<inlineCode parentName="p">{`screenshot`}</inlineCode>{`. It's not a node type that HAST recognizes.`}</p>
    <p>{`You can fix that with a HAST handler. Like this`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">const screenshotHandler = (h, node) => {
    const props = { node };

    return h(node, "screenshot", props);
};
`}</code></pre>
    <p><inlineCode parentName="p">{`screenshotHandler`}</inlineCode>{` is a function that takes an `}<inlineCode parentName="p">{`h`}</inlineCode>{` function and a `}<inlineCode parentName="p">{`node`}</inlineCode>{` as its arguments. `}<inlineCode parentName="p">{`h`}</inlineCode>{` is short for `}<inlineCode parentName="p">{`createElement`}</inlineCode>{` in the AST rendering world.`}</p>
    <p>{`No I don't know why `}<inlineCode parentName="p">{`h`}</inlineCode>{`, but everyone from React, to Preact, and Vue uses it. They all have their own implementation. The particular implementation you get depends on which Remark renderer you're using.`}</p>
    <p>{`This is your chance to create elements with the correct `}<inlineCode parentName="p">{`props`}</inlineCode>{`, types and children.`}</p>
    <p>{`Because I'm using `}<inlineCode parentName="p">{`remark-react`}</inlineCode>{`, I kept my node type as `}<inlineCode parentName="p">{`screenshot`}</inlineCode>{` and gave it the `}<inlineCode parentName="p">{`node`}</inlineCode>{` itself as props. You might want to use this opportunity to construct a more proper HTML tree.`}</p>
    <h2 {...{
      "id": "3-a-renderer"
    }}>{`3. A renderer`}</h2>
    <p>{`I'm using `}<inlineCode parentName="p">{`remark-react`}</inlineCode>{`. It takes a markdown AST and transforms it to a tree of React components for easy rendering in React apps. No `}<inlineCode parentName="p">{`dangerouslySetInnerHTML`}</inlineCode>{` mess here. ✌️`}</p>
    <p>{`Another trick that `}<inlineCode parentName="p">{`remark-react`}</inlineCode>{` enables is using custom React components to render custom HAST nodes.`}</p>
    <p>{`So I built a `}<inlineCode parentName="p">{`<Screenshot>`}</inlineCode>{` component.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">import React, { useState, useEffect } from "react";

function Screenshot({ node }) {
    const [image, setImage] = useState("/lg.pink-pig-ajax-loader.gif");

    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(node.url),
                    url = await res.text();

                setImage(url);
            } catch (e) {
                setImage("/undraw_warning_cyit.png");
            }
        })();
    }, [node]);

    return (
        <a href={node.link} target="_blank" rel="noopener noreferrer">
            <img src={image} style={{ maxWidth: 480 }} alt={node.value} />
        </a>
    );
}

export default Screenshot;
`}</code></pre>
    <p>{`Takes an AST `}<inlineCode parentName="p">{`node`}</inlineCode>{` as its prop and returns a linked image. At first the image is a gif spinner, then it turns into a screenshot.`}</p>
    <p><inlineCode parentName="p">{`useState`}</inlineCode>{` keeps track of the current image URL. `}<inlineCode parentName="p">{`useEffect`}</inlineCode>{` runs a `}<inlineCode parentName="p">{`fetch`}</inlineCode>{` request talking to my screenshot lambda.`}</p>
    <p><img parentName="p" {...{
        "src": "/d303c70e5a166b1320d4d5c4002ed742/sEoa8lP.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "putting-it-all-together"
    }}>{`Putting it all together`}</h2>
    <p>{`The final step in the puzzle is putting all this together. You'll need some way to intake markdown and somewhere to put the output.`}</p>
    <p>{`Transforming from markdown to your output looks like this`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">import remark from "remark";
import remark2react from "remark-react";
import urlThumbnail from "./remarkUrlThumbnail";
import Screenshot from "../Screenshot";

export const remarkCompile = input =>
    new Promise((resolve, reject) => {
        remark()
            .use(urlThumbnail, {
                domains: [
                    "m.twitter.com",
                    "twitter.com",
                    "youtube.com",
                    "youtu.be"
                ]
            })
            .use(remark2react, {
                sanitize: false,
                remarkReactComponents: {
                    screenshot: Screenshot
                },
                toHast: {
                    handlers: {
                        screenshot: screenshotHandler
                    }
                }
            })
            .process(input, (err, output) => {
                if (err) {
                    reject(err);
                } else {
                    resolve(output);
                }
            });
    });
`}</code></pre>
    <p>{`We have a `}<inlineCode parentName="p">{`remarkCompile`}</inlineCode>{` function that takes an `}<inlineCode parentName="p">{`input`}</inlineCode>{`, which is markdown, and returns a promise. Promise resolves with the final `}<inlineCode parentName="p">{`output`}</inlineCode>{`, or rejects with an error.`}</p>
    <p>{`Inside our promise, we instantiate `}<inlineCode parentName="p">{`remark()`}</inlineCode>{` and feed it a series of plugins via `}<inlineCode parentName="p">{`use()`}</inlineCode>{` calls. First our `}<inlineCode parentName="p">{`urlThumbnail`}</inlineCode>{` plugin, then the `}<inlineCode parentName="p">{`remark2react`}</inlineCode>{` renderer.`}</p>
    <p>{`You can put as many plugins as you want in between.`}</p>
    <p>{`Second argument you pass into `}<inlineCode parentName="p">{`use()`}</inlineCode>{` goes into your plugin as a function argument. That's how we pass a list of domains to `}<inlineCode parentName="p">{`urlThumbnail`}</inlineCode>{` and a bunch of config to `}<inlineCode parentName="p">{`remark2react`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="javascript">.use(remark2react, {
    sanitize: false,
    remarkReactComponents: {
        screenshot: Screenshot
    },
    toHast: {
        handlers: {
            screenshot: screenshotHandler
        }
    }
})
`}</code></pre>
    <p>{`We have to tell `}<inlineCode parentName="p">{`remark2react`}</inlineCode>{` to avoid sanitizing our HAST because we're using custom nodes. The `}<inlineCode parentName="p">{`screenshot`}</inlineCode>{` node.`}</p>
    <p><inlineCode parentName="p">{`remarkReactComponents`}</inlineCode>{` lets us define mappings from HAST nodes to React components. This is where you'd render links or images or whatever with a custom component. It's also where we say that screenshots render as `}<inlineCode parentName="p">{`<Screenshot>`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`handlers`}</inlineCode>{` is where we list custom HAST handlers. Telling it how to take a custom markdown node and transform it to a custom HTML node.`}</p>
    <p>{`And that's how you build a custom Markdown extension for your webapp. In a nutshell.`}</p>
    <p>{`Happy hacking 🤓`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      